// Lightweight CRM page slug registry (keeps the 308 kB crmPagesData out of the main bundle)
export const CRM_PAGE_SLUGS = new Set<string>([
  'whatsapp-crm',
  'whatsapp-crm-integration',
  'whatsapp-business-api',
  'whatsapp-shared-inbox',
  'multi-agent-whatsapp-inbox',
  'whatsapp-crm-automation',
  'whatsapp-lead-management',
  'bulk-whatsapp-messaging',
  'bulk-whatsapp-marketing-dubai',
  'hubspot-whatsapp',
  'whatsapp-analytics',
  'whatsapp-team-inbox',
  'whatsapp-broadcast',
  'whatsapp-customer-segmentation',
  'whatsapp-crm-uae',
  'whatsapp-crm-india',
  'whatsapp-agent-management',
  'whatsapp-lead-generation',
  'whatsapp-marketing-automation',
  'whatsapp-crm-dubai',
  'whatsapp-business-api-uae',
  'whatsapp-business-api-dubai',
  'whatsapp-business-api-india'
]);

export function isCrmPageSlug(slug: string): boolean {
  return CRM_PAGE_SLUGS.has(slug);
}
